import React, { useState } from "react";
import { connect } from "react-redux";
import { logToAndylitics } from "../../api/andyliticsApi";
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Link } from "react-router-dom";
import { logUI } from '../../api/andyliticsApi';
import * as Tools from "../../helpers/Tools";

const THRIVE_URL = "https://bswh.livehealthyignite.com/users/sign_in";

const EarnPointsTile = props => {
    const [openModal, toggleModal] = useState(false);
    const { thrive, hasMyChart, serverData } = props;
    const enableCustomDirectScheduling = serverData && serverData.enableCustomDirectScheduling ? serverData.enableCustomDirectScheduling : false;
    const thriveMainUrl = THRIVE_URL; //thrive && thrive.thriveMainUrl ? thrive.thriveMainUrl : "";
    const logActivity = () => {
        logToAndylitics('MBHWeb.EarnPoints.VisitThrive.Redirect', new Date(), thriveMainUrl);
    }
    return <div className="card points-tile">
        <div className="card-header">
            <div className="row">
                <div className="col-12">
                    <div className="card-heading earn-points-heading">
                        <img className="points-image"
                                src="images/points.svg"
                                alt="earnpoint icon" />
                       
                        <div className="points-tile__heading pl-2">EARN THRIVE POINTS</div>
                        <span className="icon-question" onClick={() => toggleModal(!openModal)} />
                    </div>
                </div>
            </div>
        </div>
        <div className="card-body mt-2">
            <div className="row">
                <div className="col-12">
                    <p>Earn points by completing a Preventive Care Exam, talking with a Wellness coach, or completing a Thrive Culture Activity.</p>

                    <p>Track and learn more about points at Thrive365.</p>
                    <div className="col-12 text-right">
                        <a className="card-link" href={thriveMainUrl} target="_blank" onClick={() => logActivity()}>
                            VISIT THRIVE365
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <Modal className="points-tile__modal" isOpen={openModal} toggle={() => toggleModal(!openModal)} centered>
            <ModalHeader className="text-center">
                <span><img className="points-image"
                    src="images/points.svg"
                    alt="earnpoint icon"
                />Earn Points</span>
            </ModalHeader>
            <ModalBody>
                <div className="row">
                    <div className="col-12">
                        <p className="any-question">If you have questions about missing points or the requirements for earning points, please read our
                        {serverData && serverData.wellnessFAQURL && <a className="card-link" href={serverData.wellnessFAQURL} target="_blank"> FAQs.</a>}                           
                            <br /><br />
                            *Does not apply to employees with non-BSWH coverage.
                        </p>
                    </div>
                    <div className="col-12">
                        <ul className="angle-bullets">
                            <li>
                                <span className="points-heading">Preventive Care Exam</span>
                                <p className="points-description">If you haven't already, be sure to schedule your annual wellness-visit with your doctor.</p>
                                {!hasMyChart ?
                                    <a className="card-link" href="http://www.bswhealth.com/" target="_blank">SCHEDULE APPOINTMENT</a> :
                                    <Link className="card-link" to={{
                                        pathname: enableCustomDirectScheduling ? "/schedule/DirectSchedule" : "/findcare",
                                        state: { fromPreventiveCareTile: true }
                                    }} onClick={() => logUI("MBHWeb.UI.EarnPoints.Schedule", new Date(), Tools.getURLPath())}>SCHEDULE APPOINTMENT</Link>
                                }                                

                            </li>
                            <li>
                                <span className="points-heading">Wellness Coaching</span>
                                <p className="points-description">Schedule a meeting with a Wellness Coach. Available to you and your spouse.</p>
                                <Link className="card-link" to={{
                                    pathname: "https://outlook.office365.com/owa/calendar/ThriveWellnessCoaching@swmail.onmicrosoft.com/bookings/" }} onClick={() => logUI("MBHWeb.UI.EarnpointsTile.ThriveWellnessCoaching", new Date(), Tools.getURLPath())}
                                    target="_blank">BOOK A SESSION</Link>
                            </li>
                            <li>
                                <span className="points-heading">Well-being Journeys</span>
                                <p className="points-description">Well-being Journeys set you on a path of education and activities to promote awareness in the areas you are intrested in.</p>
                                <Link className="card-link" to={{ pathname: '/wellbeingJourney' }} onClick={() => logUI("MBHWeb.UI.EarnPointsTile.StartJourneyClicked", new Date(), Tools.getURLPath())}>START A JOURNEY</Link>
                            </li>
                            <li>
                                <span className="points-heading">Culture Activities</span>
                                <p className="points-description">Approved Thrive365 events you can participate in on your road to Well-being.</p>
                                <Link className="card-link" to={{ pathname: `${thriveMainUrl}` }} target="_blank">LEARN MORE</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <button className="btn text-btn" onClick={() => toggleModal(false)}>OKAY</button>
            </ModalFooter>
        </Modal>
    </div>;
}
const mapStateToProps = (state) => {
    return {
        thrive: state.header.thrive,
        hasMyChart: !state.common.epicEHRDown && state.domain.hm,
        serverData: state.session.serverData
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EarnPointsTile);

